'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { KBArticlesToURLs, KBArticles } from 'AdsUI/lib/Constants';

const getSlug = url => {
  const trailingSlash = url.lastIndexOf('/');
  const anchorLinkHash = url.lastIndexOf('#');
  return anchorLinkHash !== -1 ? url.slice(trailingSlash + 1, anchorLinkHash) : url.slice(trailingSlash + 1, url.length);
};

const getFullArticleUrl = ({
  kbArticle,
  kbSection
}) => {
  const articleUrl = KBArticlesToURLs[kbArticle];
  return kbSection ? `${articleUrl}#${kbSection}` : `${articleUrl}`;
};

class KnowledgeBaseLink extends Component {
  constructor(props) {
    super(props);
    this.onLinkClick = this.onLinkClick.bind(this);
  }

  onLinkClick() {
    const {
      kbArticle,
      context,
      kbSection,
      onClick
    } = this.props;

    if (onClick) {
      onClick();
    }

    usageTracker.track('helpAction', Object.assign({
      action: 'Clicked KB link',
      kbArticle,
      kbSlug: getSlug(KBArticlesToURLs[kbArticle]),
      context
    }, kbSection && {
      kbSection
    }));
  }

  render() {
    const {
      kbArticle,
      kbSection,
      children,
      useZorse
    } = this.props;
    return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      url: getFullArticleUrl({
        kbArticle,
        kbSection
      }),
      onClick: this.onLinkClick,
      useZorse: useZorse,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learnMore"
      })
    });
  }

}

KnowledgeBaseLink.propTypes = {
  kbArticle: PropTypes.oneOf(Object.values(KBArticles)).isRequired,
  kbSection: PropTypes.string,
  context: PropTypes.string.isRequired,
  children: PropTypes.node,
  useZorse: PropTypes.bool,
  onClick: PropTypes.func
};
KnowledgeBaseLink.defaultProps = {
  useZorse: true
};
export default KnowledgeBaseLink;